import { IconDialogAlert } from '@direct-frontend/components';
import { enhanceFeedbackBlank } from '../lib/enhanceFeedbackBlank';

export const FeedbackBlankError = enhanceFeedbackBlank({
    header: <IconDialogAlert size="64" />,
});
